import {APP_ROUTES} from "../app";

const DEFAULT_INDUSTRIES_ROUTE = '/industries';

export const LANGUAGES_DROPDOWN_MENU_LIST = [
    {
        title: 'English',
        locale: 'en',
    },
    {
        title: 'Philippine',
        locale: 'ph',
    }
];

export enum TOP_HEADER_CONTENT {
    phoneNumber = '+63 998 550-97-38',
    email = 'edjr23deloria@gmail.com',
}

export enum MAIN_HEADER_CONTENT {
    aboutUs = 'About us',
    industries = 'Industries',
    products = 'Products',
    solutions = 'Solutions',
    services = 'Services',
    projects = 'Projects',
    news = 'News',
    contacts = 'Contacts',
}

export enum MAIN_HEADER_CONTENT_PH {
    aboutUs = 'Tungkol Sa Amin',
    industries = 'Industriya',
    products = 'Produkto',
    solutions = 'Solusyon',
    services = 'Serbisyo',
    projects = 'Proyekto',
    news = 'Balita',
    contacts = 'Ugnayan',
}

export const INDUSTRIES_DROP_DOWN_MENU_LIST = [
    {
        title: 'Marine Vessels',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/marine-vessels`,
    },
    {
        title: 'Construction',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/construction`,
    },
    {
        title: 'Logistics',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/logistics`,
    },
    {
        title: 'Agriculture',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/agriculture`,
    },
    {
        title: 'Diesel Generators',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/diesel-generators`,
    },
];

export const INDUSTRIES_DROP_DOWN_MENU_LIST_PH = [
    {
        title: 'Mga Sasakyang Pandagat',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/marine-vessels`,
    },
    {
        title: 'Konstruksyon',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/construction`,
    },
    {
        title: 'Logistika',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/logistics`,
    },
    {
        title: 'Agrikultura',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/agriculture`,
    },
    {
        title: 'Mga Diesel Generator',
        href: `${DEFAULT_INDUSTRIES_ROUTE}/diesel-generators`,
    },
];

export const PRODUCTS_DROP_DOWN_MENU_LIST = [
    {
        title: 'Fuel level sensors',
        href: `${APP_ROUTES.PRODUCTS}/fuel-level-sensors`,
    },
    {
        title: 'Fuel flow meters',
        href: `${APP_ROUTES.PRODUCTS}/fuel-flow-meters`,
    },
    {
        title: 'Telematics gateway',
        href: `${APP_ROUTES.PRODUCTS}/telematic-gateway`,
    },
    {
        title: 'Accessories',
        href: `${APP_ROUTES.PRODUCTS}/accessories`,
    },
    {
        title: 'Monitoring platform',
        href: `${APP_ROUTES.PRODUCTS}/monitoring-platform`,
    },
];

export const PRODUCTS_DROP_DOWN_MENU_LIST_PH = [
    {
        title: 'Mga Sensor ng Antas ng Gasolina',
        href: `${APP_ROUTES.PRODUCTS}/fuel-level-sensors`,
    },
    {
        title: 'Mga Flow Meter ng Gasolina',
        href: `${APP_ROUTES.PRODUCTS}/fuel-flow-meters`,
    },
    {
        title: 'Telematics Gateway',
        href: `${APP_ROUTES.PRODUCTS}/telematic-gateway`,
    },
    {
        title: 'Mga Aksesorya',
        href: `${APP_ROUTES.PRODUCTS}/accessories`,
    },
    {
        title: 'Monitoring platform',
        href: `${APP_ROUTES.PRODUCTS}/monitoring-platform`,
    },
];


export const SOLUTIONS_DROP_DOWN_MENU_LIST = [
    {
        title: 'Fuel consumption monitoring',
        href: `${APP_ROUTES.SOLUTIONS}/fuel-consumption-monitoring`,
    },
    {
        title: 'Axle load monitoring',
        href: `${APP_ROUTES.SOLUTIONS}/axle-load-monitoring`,
    },
    {
        title: 'Predictive Maintenance',
        href: `${APP_ROUTES.SOLUTIONS}/predictive-maintrance`,
    },
    {
        title: 'Engine run time and performance monitoring',
        href: `${APP_ROUTES.SOLUTIONS}/engine-performance-monitoring`,
    },
];

export const SOLUTIONS_DROP_DOWN_MENU_LIST_PH = [
    {
        title: 'Pagsubaybay sa Konsumo ng Gasolina',
        href: `${APP_ROUTES.SOLUTIONS}/fuel-consumption-monitoring`,
    },
    {
        title: 'Pagsubaybay sa Load ng Axle',
        href: `${APP_ROUTES.SOLUTIONS}/axle-load-monitoring`,
    },
    {
        title: 'Predictive Maintenance',
        href: `${APP_ROUTES.SOLUTIONS}/predictive-maintrance`,
    },
    {
        title: 'Pagsubaybay sa Oras ng Takbo at Pagganap ng Makina',
        href: `${APP_ROUTES.SOLUTIONS}/engine-performance-monitoring`,
    },
];

export const SERVICES_DROP_DOWN_MENU_LIST = [
    {
        title: 'Monitoring services',
        href: `${APP_ROUTES.SERVICES}/monitoring-services`,
    },
    {
        title: 'Installation services',
        href: `${APP_ROUTES.SERVICES}/installation-services`,
    },
    {
        title: 'Warranty and After-Sales Service',
        href: `${APP_ROUTES.SERVICES}/warranty-services`,
    },
];

export const SERVICES_DROP_DOWN_MENU_LIST_PH = [
    {
        title: 'Mga Serbisyo sa Pagsubaybay',
        href: `${APP_ROUTES.SERVICES}/monitoring-services`,
    },
    {
        title: 'Mga Serbisyo sa Pag-install',
        href: `${APP_ROUTES.SERVICES}/installation-services`,
    },
    {
        title: 'Garantiyang Serbisyo at After-Sales Support',
        href: `${APP_ROUTES.SERVICES}/warranty-services`,
    },
];